import { render, staticRenderFns } from "./ExternalApp.vue?vue&type=template&id=45515fb1&scoped=true&"
import script from "./ExternalApp.vue?vue&type=script&lang=ts&"
export * from "./ExternalApp.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalApp.vue?vue&type=style&index=0&id=45515fb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45515fb1",
  null
  
)

export default component.exports